// src/etapas/EtapaDadosCliente.js
import React, { useEffect, useState } from 'react';
import api from '../services/api';

function EtapaDadosCliente({ onNext, onBack, setDados, dados }) {
  const [cliente, setCliente] = useState({});
  const [tipo, setTipo] = useState('');

  useEffect(() => {
    const atual = dados.etapa1?.cliente || {};
    const tipoCliente = atual.cpfCnpj?.length <= 11 ? 'pf' : 'pj';
    setTipo(tipoCliente);
    setCliente({ ...atual });
  }, [dados]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Campos de endereço
    const camposEndereco = ['logradouro', 'numero', 'bairro', 'cidade', 'uf', 'cep', 'complemento'];

    if (camposEndereco.includes(name)) {
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          [name]: value
        }
      }));
    } else {
      setCliente((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAvancar = () => {
    setDados((prev) => ({
      ...prev,
      etapa1: {
        cliente: {
          nome: cliente.nome,
          cpfCnpj: cliente.cpfCnpj,
          telefone: cliente.telefone,
          whatsapp: cliente.whatsapp,
          email: cliente.email,
          endereco: {
            logradouro: cliente.endereco?.logradouro || '',
            numero: cliente.endereco?.numero || '',
            complemento: cliente.endereco?.complemento || '',
            bairro: cliente.endereco?.bairro || '',
            cidade: cliente.endereco?.cidade || '',
            uf: cliente.endereco?.uf || '',
            cep: cliente.endereco?.cep || ''
          }
        }
      },
      etapa2: {
        confirmado: true
      }
    }));

    console.log('Dados atualizados após etapa 2:', cliente);
    onNext();
  };

  const consultarCep = async () => {
    try {
      const cepLimpo = cliente.endereco?.cep.replace(/\D/g, "");
      if (cepLimpo.length !== 8) {
        alert("CEP inválido!");
        return;
      }

      const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (data.erro) {
        alert("CEP não encontrado!");
        return;
      }

      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          logradouro: data.logradouro
        }
      }));
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          complemento: data.complemento
        }
      }));
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          bairro: data.bairro
        }
      }));
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          cidade: data.localidade
        }
      }));
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          cidade: data.localidade
        }
      }));
      setCliente((prev) => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          uf: data.uf
        }
      }));
    } catch (error) {
      console.error("Erro ao consultar CEP:", error);
      alert("Não foi possível buscar o CEP.");
    }
  };

  return (
    <div className="container">
      <h4 className="fw-semibold mb-4 text-center" style={{ fontSize: '1.5rem', color: '#444' }}>
        Dados do Cliente ({tipo === 'pf' ? 'Pessoa Física' : 'Pessoa Jurídica'})
      </h4>

      <div className="row">
        {tipo === 'pj' && (
          <>
            <div className="col-md-6 mb-3">
              <label className="form-label">Razão Social</label>
              <input type="text" name="razaoSocial" className="form-control" value={cliente.razaoSocial || ''} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Nome Fantasia</label>
              <input type="text" name="nomeFantasia" className="form-control" value={cliente.nomeFantasia || ''} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">CNPJ</label>
              <input type="text" name="cpfCnpj" className="form-control" value={cliente.cpfCnpj || ''} readOnly />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Inscrição Estadual</label>
              <input type="text" name="ie" className="form-control" value={cliente.ie || ''} onChange={handleChange} />
            </div>
          </>
        )}

        {tipo === 'pf' && (
          <>
            <div className="col-md-6 mb-3">
              <label className="form-label">Nome</label>
              <input type="text" name="nome" className="form-control" value={cliente.nome || ''} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">CPF</label>
              <input type="text" name="cpfCnpj" className="form-control" value={cliente.cpfCnpj || ''} readOnly />
            </div>
          </>
        )}

        <div className="col-md-3 mb-3">
          <label className="form-label">CEP</label>
          <div className="input-group">
            <input
              type="text"
              name="cep"
              className="form-control"
              value={cliente.endereco?.cep || ''}
              onChange={handleChange}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={consultarCep}
            >
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>

        <div className="col-md-8 mb-3">
          <label className="form-label">Endereço</label>
          <input type="text" name="logradouro" className="form-control" value={cliente.endereco?.logradouro || ''} onChange={handleChange} />
        </div>

        <div className="col-md-2 mb-3">
          <label className="form-label">Número</label>
          <input type="text" name="numero" className="form-control" value={cliente.endereco?.numero || ''} onChange={handleChange} />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Complemento</label>
          <input type="text" name="complemento" className="form-control" value={cliente.endereco?.complemento || ''} onChange={handleChange} />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Bairro</label>
          <input type="text" name="bairro" className="form-control" value={cliente.endereco?.bairro || ''} onChange={handleChange} />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Cidade</label>
          <input type="text" name="cidade" className="form-control" value={cliente.endereco?.cidade || ''} onChange={handleChange} />
        </div>

        <div className="col-md-2 mb-3">
          <label className="form-label">UF</label>
          <input type="text" name="uf" className="form-control" value={cliente.endereco?.uf || ''} onChange={handleChange} />
        </div>

        <div className="col-md-5 mb-3">
          <label className="form-label">Telefone</label>
          <input type="text" name="telefone" className="form-control" value={cliente.telefone || ''} onChange={handleChange} />
        </div>

        <div className="col-md-5 mb-3">
          <label className="form-label">WhatsApp</label>
          <input type="text" name="whatsapp" className="form-control" value={cliente.whatsapp || ''} onChange={handleChange} />
        </div>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>
        <button className="btn btn-success" onClick={handleAvancar}>Avançar</button>
      </div>
    </div>
  );
}

export default EtapaDadosCliente;
